export const availableStatusOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
  { value: 'Nearly Full', label: 'Nearly Full' },
];

export const categories = [
  { value: 'Designer', label: 'Designer' },
  { value: 'Furniture', label: 'Furniture' },
  { value: 'Designer & Furniture', label: 'Designer & Furniture' },
];
